import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { SettingsProvider } from "@/lib/settings";
import { AdminAuthProvider, ProtectedRoute } from "@/lib/adminAuth";

import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Venues from "@/pages/Venues";
import VenueDetail from "@/pages/VenueDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";

import AdminLogin from "@/pages/admin/AdminLogin";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminEvents from "@/pages/admin/AdminEvents";
import EventEditor from "@/pages/admin/EventEditor";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import CheckIn from "@/pages/admin/CheckIn";
import AdminVenues from "@/pages/admin/AdminVenues";
import Reports from "@/pages/admin/Reports";
import Campaigns from "@/pages/admin/Campaigns";
import Contacts from "@/pages/admin/Contacts";
import Settings from "@/pages/admin/Settings";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
      <AdminAuthProvider>
        <SettingsProvider>
          <Routes>
            {/* Public */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:slug" element={<EventDetail />} />
              <Route path="/events/:slug/tickets" element={<Checkout />} />
              <Route path="/venues" element={<Venues />} />
              <Route path="/venues/:slug" element={<VenueDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/legal/:page" element={<Legal />} />
              <Route path="/orders/:orderNumber" element={<OrderConfirmation />} />
            </Route>
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot-password" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="events" element={<ProtectedRoute roles={["OWNER", "EVENT_MANAGER"]}><AdminEvents /></ProtectedRoute>} />
              <Route path="events/:id" element={<ProtectedRoute roles={["OWNER", "EVENT_MANAGER"]}><EventEditor /></ProtectedRoute>} />
              <Route path="orders" element={<ProtectedRoute roles={["OWNER", "EVENT_MANAGER"]}><AdminOrders /></ProtectedRoute>} />
              <Route path="customers" element={<ProtectedRoute roles={["OWNER", "EVENT_MANAGER"]}><AdminCustomers /></ProtectedRoute>} />
              <Route path="checkin" element={<CheckIn />} />
              <Route path="venues" element={<ProtectedRoute roles={["OWNER", "EVENT_MANAGER"]}><AdminVenues /></ProtectedRoute>} />
              <Route path="reports" element={<ProtectedRoute roles={["OWNER", "EVENT_MANAGER"]}><Reports /></ProtectedRoute>} />
              <Route path="campaigns" element={<ProtectedRoute roles={["OWNER", "EVENT_MANAGER"]}><Campaigns /></ProtectedRoute>} />
              <Route path="contacts" element={<ProtectedRoute roles={["OWNER", "EVENT_MANAGER"]}><Contacts /></ProtectedRoute>} />
              <Route path="settings" element={<ProtectedRoute roles={["OWNER"]}><Settings /></ProtectedRoute>} />
            </Route>
          </Routes>
        </SettingsProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;
